import { render, staticRenderFns } from "./furniture.pug?vue&type=template&id=56f94815&lang=pug&"
import script from "./furniture.js?vue&type=script&lang=js&"
export * from "./furniture.js?vue&type=script&lang=js&"
import style0 from "./furniture.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f94815')) {
      api.createRecord('56f94815', component.options)
    } else {
      api.reload('56f94815', component.options)
    }
    module.hot.accept("./furniture.pug?vue&type=template&id=56f94815&lang=pug&", function () {
      api.rerender('56f94815', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/furniture/index.vue"
export default component.exports